/* eslint-disable react/jsx-props-no-spreading, react/require-default-props */
import React from 'react';
import { SingleDatePicker } from '@sede-enterprise/shell-ds-react-framework';
import { ISingleDatePickerProps } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/DatePicker/components/SingleDatePicker/SingleDatePicker.types';
import { Controller, UseControllerProps } from 'react-hook-form';
import { Dayjs } from 'dayjs';
import ErrorMessage from '../ErrorMessage';
import { IMemoisedComponentProp } from '../../types/Common.type';

interface ITextInputControl extends IMemoisedComponentProp {
  label: string;
  handleOnChange?: (date: Dayjs | null) => void;
  inputProps?: ISingleDatePickerProps;
  controllerProps: UseControllerProps;
}

const FormControlDatePicker: React.FC<ITextInputControl> = ({
  methods,
  label,
  handleOnChange,
  inputProps,
  controllerProps,
}) => {
  const {
    formState: { errors },
    control,
  } = methods;
  const { name } = controllerProps;
  const fieldError =
    typeof name === 'string'
      ? name.split('.').reduce((acc, key) => acc?.[key], errors as any)
      : undefined;
  const errorMessage = fieldError?.message;
  return (
    <>
      <Controller
        control={control}
        {...controllerProps}
        render={({ field: { onChange, value } }) => (
          <div>
            <span>{label}</span>
            <SingleDatePicker
              onChange={(date) => {
                // Update RHF state first so dependent validations read the latest value.
                onChange(date);
                if (handleOnChange) {
                  handleOnChange(date);
                }
              }}
              data-testid={name}
              value={value}
              invalid={!!fieldError}
              {...inputProps}
            />
          </div>
        )}
      />
      {errorMessage && <ErrorMessage>{errorMessage as string}</ErrorMessage>}
    </>
  );
};
export default FormControlDatePicker;
